import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ roles }) {
  const { loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="p-8 text-sm font-semibold text-slate-600">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/account" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  if (roles?.length && !roles.includes(user.role)) {
    return <Navigate to="/my-account" replace />;
  }

  return <Outlet />;
}
